/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Menusectioncount2Inputs */

const en_menusectioncount2 = /** @type {(inputs: Menusectioncount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sections`)
};

const de_menusectioncount2 = /** @type {(inputs: Menusectioncount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Bereiche`)
};

/**
* | output |
* | --- |
* | "{count} sections" |
*
* @param {Menusectioncount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menusectioncount2 = /** @type {((inputs: Menusectioncount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menusectioncount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menusectioncount2(inputs)
	return de_menusectioncount2(inputs)
});
export { menusectioncount2 as "menuSectionCount" }